import React from 'react';

import * as ST from './styled';

export interface IImageProps {
    imgBgColor?: string,
    imageSrc?: string,
    imageAlt?: string,
    textForImage?: string,
    bgForImage?: string,
    channelCount?: number, // костыль для вывода каналов в углу картинки
    isMega?: boolean,
}

export const ImageElement = ({
    imgBgColor,
    imageSrc,
    imageAlt = 'иконка',
    textForImage = '',
    bgForImage,
    channelCount,
    isMega,
} : IImageProps): JSX.Element => {
    const displayText = !imageSrc && !!textForImage;

    if (displayText) {
        return (
            <ST.ImageElementWithText imgSrc={bgForImage} title={imageAlt} isMega={isMega}>
                {textForImage}
            </ST.ImageElementWithText>
        );
    }

    return (
        <ST.ImageElement
            imgBgColor={imgBgColor}
            channelCount={channelCount}
        >
            <img src={`${imageSrc}`} alt={imageAlt} />
        </ST.ImageElement>
    );
};
